import type { MaybeRefOrGetter } from 'vue';
import { toValue, watch } from 'vue';
import { useColorMode } from '#imports';

// Syncs the backend appearance preference to @nuxt/color-mode on load.
export function useAppearance(appearance: MaybeRefOrGetter<string | null | undefined>) {
	const colorMode = useColorMode();

	watch(() => toValue(appearance), (value) => {
		// undefined = user not loaded yet; keep the persisted mode to avoid a flash.
		// null = loaded user who never picked a theme, which means the system default.
		if (value === undefined) {
			return;
		}

		colorMode.preference = value ?? 'system';
	}, { immediate: true });
}
